import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

import { ComboPopulation } from 'app/model/combo-population';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Menu } from './../../../core/services/menu.service';
import { MenuService } from '@core';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { PrivacyPolicyDTO } from 'app/model/privacy-policy.enum';
import { JwtUser } from 'app/model/jwt-user';
import { UrlConfigService } from 'app/service/url-config.service';

export class AuthenticationToken {
  user: string;
  token: string;
  userTeamType: string;
  email: string;
  loginId: string;
  clientList: ComboPopulation[];
  menu: string;
  defaultHomeScreenId: string;
  defaultHomeScreenUrl: string;
  dbName: string;
}

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  TOKEN = 'token';
  USER_NAME = 'authenticatedUser';
  USER_TEAM_TYPE = 'userTeamType';
  USER_EMAIL = 'email';
  CLIENT_LIST = 'clientList';
  TIME_OFFSET = 'timeOffset';
  MENU_LIST = 'menulist';
  DEFAULT_HOME_SCREEN_ID = 'defaultHomeScreenId';
  DEFAULT_HOME_SCREEN_URL = 'defaultHomeScreenUrl';
  DB_NAME = 'dbName';

  public username: String;
  public password: String;

  url: string;

  constructor(
    private urlConfigService: UrlConfigService,
    private http: HttpClient,
    private menuService: MenuService
  ) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  authenticationService(username: String, password: String) {
    if (!this.url) {
      this.url = this.urlConfigService.apiServerUrl;
    }
    return this.http
      .post<AuthenticationToken>(this.url + 'login', {
        userName: username,
        password: password,
      })
      .pipe(
        map(res => {
          this.registerSuccessfulLogin(
            res.user,
            res.token,
            res.email,
            res.userTeamType,
            res.clientList,
            res.menu,
            res.defaultHomeScreenId,
            res.defaultHomeScreenUrl,
            res.dbName
          );
        }),
        catchError((error: HttpErrorResponse) => {
          return throwError(error.error.message);
        })
      );
  }

  registerSuccessfulLogin(
    username,
    token,
    email,
    userTeamType,
    clientList,
    menuList,
    defaultHomeScreenId,
    defaultHomeScreenUrl,
    dbName,
  ) {
    menuList = menuList.toString();
    localStorage.setItem(this.USER_NAME, username);
    localStorage.setItem(this.TOKEN, token);
    localStorage.setItem(this.USER_EMAIL, email);
    localStorage.setItem(this.USER_TEAM_TYPE, userTeamType);
    localStorage.setItem(this.CLIENT_LIST, JSON.stringify(clientList));
    localStorage.setItem(this.MENU_LIST, menuList);
    localStorage.setItem(this.DEFAULT_HOME_SCREEN_ID, defaultHomeScreenId);
    localStorage.setItem(this.DEFAULT_HOME_SCREEN_URL, defaultHomeScreenUrl);
    localStorage.setItem(this.DB_NAME, dbName);
  }

  logout() {
    localStorage.clear();
    this.username = null;
    this.password = null;
  }

  isUserLoggedIn() {
    let userToken = localStorage.getItem('token');
    if (userToken == null) {
      return false;
    } else {
      return this.http.post(this.url + `validateToken`, userToken);
    }
  }

  getLoggedInUserName() {
    let user = localStorage.getItem(this.USER_NAME);
    if (user === null) return '';
    return user;
  }

  afterLoginUserDetail(token: String) {
    if (!this.url) {
      this.url = this.urlConfigService.apiServerUrl;
    }
    return this.http.post<AuthenticationToken>(this.url + 'afterLoginUserDetail', {}).pipe(
      map(res => {
        this.registerSuccessfulLogin(
          res.user,
          token,
          res.email,
          res.userTeamType,
          res.clientList,
          res.menu,
          res.defaultHomeScreenId,
          res.defaultHomeScreenUrl,
          res.dbName,
        );
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error.error.message);
      })
    );
  }
  insertprivacyPolicy(privacyPolicyDTO: PrivacyPolicyDTO) {
    return this.http.post<AuthenticationToken>(this.url + 'privacyPolicy', privacyPolicyDTO);
  }

  checkforprivacyPolicy(privacyPolicyDTO: PrivacyPolicyDTO) {
    return this.http.post<AuthenticationToken>(
      this.url + 'checkforPrivacyPolicy',
      privacyPolicyDTO
    );
  }

  sessionAuthentication(dto: JwtUser) {
    if (!this.url) {
      this.url = this.urlConfigService.apiServerUrl;
    }
    return this.http.post<AuthenticationToken>(this.url + 'sso/sessionAuthentication', dto);
  }
}
